import { GridColumnDefs } from "../../../models/Grid/gridColumnDefs";
import { useEffect, useState } from "react";
import { userManagement_LABELS } from "../../../constants/labels/UserManagement";
import MultiSelectDropdown from "../../shared/MultiSelectDropdown/MultiSelectDropdown";
import { Button } from "@mui/material";
import { ReactComponent as Apply } from "../../../assets/svg/Apply.svg";
import { ReactComponent as Reset } from "../../../assets/svg/reset.svg";
import { ReactComponent as ResendIcon } from "../../../assets/svg/Resend.svg";
import DaterangePicker from "../../shared/DaterangePicker/DaterangePicker";
import Grid from "../../shared/Grid/Grid";
import { useGetAllClinicNamesQuery } from "../../../services/rtkQueryServices/clinicService";
import * as dateFns from "date-fns";
import "./CommunicationLogsGrid.scss";
import {
  useLazyGetAllBpCommunicationLogsQuery,
  useLazyRetryUploadToBPQuery,
} from "../../../services/rtkQueryServices/communicationLogsService";
import { DELIVERY_STATUS_TYPE } from "../../../constants/enums/deliveryStatusTypes";
import Modal from "../../shared/Modal/Modal";
import { COMMUNICATION_TYPE } from "../../../constants/enums/communicationTypes";
import { useAuth } from "../../../context/AuthProvider";
import BpCommunicationLogsHistoryGrid from "./CommunicationLogsHistoryGrid/BpCoummunicationLogsHistory";
import { Utility } from "../../../utils/Utility";
import { communicationLogs_LABELS } from "../../../constants/labels/CommunicationLogs";
import ConfirmationDialog from "../../shared/ConfirmationDialog/ConfirmationDialog";
import { ReactComponent as InfoIcon } from "../../../assets/svg/info_lg.svg";
import { ReactComponent as DoneIcon } from "../../../assets/svg/Done.svg";

interface resendRequest {
  notificationDataId: number;
  processId: string;
  initiatedBy: string;
  newRecipientAddress: string;
  newCommunicationType: number;
}
function BpCommunicationLogsGrid() {
  const [rowData, setRowData] = useState<any[]>([]);
  const [rowcount, setRowCount] = useState<number>(0);
  const [searchString, setSearchString] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [isApplyFiltersEnabled, setIsApplyFiltersEnabled] =
    useState<boolean>(false);
  const [enableClear, setEnableClear] = useState<boolean>(false);
  const [resetPagination, setResetPagination] = useState<boolean>(false);
  const [showRetryResponse, setShowRetryResponse] = useState<boolean>(false);
  const [isRetrySuccess, setIsRetrySuccess] = useState<boolean>(false);
  const [logData, setLogData] = useState<any>();
  const [openResendModal, setOpenResendModal] = useState<boolean>(false);
  const getPreviousDate = (daysAgo: number) => {
    const today = new Date();
    today.setDate(today.getDate() - daysAgo);
    return today;
  };

  const [dateRange, setDateRange] = useState<any>([
    getPreviousDate(3),
    new Date(),
  ]);

  const [filterCriteria, setFilterCriteria] = useState<any>({
    pageNumber: 1,
    pageSize: 10,
    searchString: null,
    sortByColumnName: "createdDate",
    sortOrder: "desc",
    filters: [],
    timezoneOffSet: 0,
    dateRangeCondition: dateRange?.length
      ? {
          fromDate: dateRange[0]?.toLocaleDateString("fr-CA"),
          toDate: dateRange[1]?.toLocaleDateString("fr-CA"),
        }
      : null,
  });

  const [selectedClinicsList, setSelectedClinicsList] = useState<string[]>([]);
  const [statusList, setStatusList] = useState<string[]>([]);
  const [clinicsDropDownList, setClinicsDropDownList] = useState<any>([]);
  const [openFailedStatusModal, setOpenFailedStatusModal] =
    useState<boolean>(false);
  const [processId, setProcessId] = useState<any>();
  const auth = useAuth();
  const {
    isFetching,
    isSuccess,
    data: clinicNames,
  } = useGetAllClinicNamesQuery({});

  const [getBpCommunicationLogs] = useLazyGetAllBpCommunicationLogsQuery();

  useEffect(() => {
    if (isSuccess && !isFetching) {
      const resultArray = clinicNames.data.map((item: any) => ({
        clinicId: item?.clinicId?.toString(),
        clinicName: item?.clinicName,
      }));
      setClinicsDropDownList(resultArray);
    }
  }, [clinicNames]);

  const getData = () => {
    getBpCommunicationLogs(filterCriteria).then((res: any) => {
      if (res.isSuccess && !res.isLoading) {
        setRowData(res?.data?.data?.listOfCommunicationLogs);
        setRowCount(res?.data?.data?.totalCount);
      }
    });
  };

  useEffect(() => {
    getData();
  }, [filterCriteria]);
  const CommunicationLogId = (props: any) => {
    return (
      <div title={props?.data?.processId}>
        {props?.data?.processId.slice(0, 5)}
      </div>
    );
  };
  const DeliveryStatus = (props: any) => {
    return (
      <>
        <div
          className={
            "bold cursor-pointer text-decoration-underline " +
            (props?.data?.deliveryStatus === DELIVERY_STATUS_TYPE.Success
              ? "green "
              : props?.data?.deliveryStatus === DELIVERY_STATUS_TYPE.Failed
              ? "red "
              : "yellow")
          }
          onClick={() => {
            setProcessId(props?.data?.processId);
            setOpenFailedStatusModal(true);
          }}
        >
          {props?.data?.deliveryStatus === DELIVERY_STATUS_TYPE.Queued ||
          props?.data?.deliveryStatus === DELIVERY_STATUS_TYPE.InProgress
            ? "In Progress"
            : DELIVERY_STATUS_TYPE[props?.data?.deliveryStatus]}
        </div>
        <Modal
          isOpen={openFailedStatusModal && props.data.processId === processId}
          onClose={() => {
            setOpenFailedStatusModal(false);
            getData();
          }}
          title="Communication History"
          modalWidth="70%"
          closeOnOverLayClick={false}
          headerBg="var(--primary-color)"
          closeIconColor={"var(--white)"}
          headerLogo={<></>}
          modalHeaderBottomStyle={{
            borderBottom: "1px solid var(--primary-color)",
          }}
        >
          {openFailedStatusModal && props.data.processId === processId && (
            <BpCommunicationLogsHistoryGrid data={props?.data} />
          )}
        </Modal>
      </>
    );
  };
  const [retryUpload] = useLazyRetryUploadToBPQuery();
  const handleSubmit = (data: any) => {
    var request: resendRequest = {
      notificationDataId: data?.notificationId,
      processId: data?.processId,
      newRecipientAddress: data?.bpSiteId,
      newCommunicationType: COMMUNICATION_TYPE.BP,
      initiatedBy: auth?.authClaims?.userName || "",
    };
    retryUpload(request).then((res) => {
      if (res.isSuccess && !res.isLoading) {
        setShowRetryResponse(true);
        setIsRetrySuccess(true);
        setOpenResendModal(false);
      } else if (res.isError) {
        setShowRetryResponse(true);
        setIsRetrySuccess(false);
        setOpenResendModal(false);
      }
    });
  };
  const PatientName = (props: any) => {
    return (
      <div title={props?.data?.recipientName}>{props?.data?.recipientName}</div>
    );
  };
  const Actions = (props: any) => {
    const createdAtDate = new Date(props.data?.initialAppLogDate);
    const ninetyDaysAgo = new Date();
    ninetyDaysAgo.setDate(ninetyDaysAgo.getDate() - 90);

    return (
      <div
        title={
          (createdAtDate !== undefined && createdAtDate < ninetyDaysAgo) ||
          props?.data?.deliveryStatus === DELIVERY_STATUS_TYPE.Success
            ? "Cannot Resend Documents."
            : "Resend"
        }
      >
        <Button
          className="cursor-pointer"
          onClick={() => {
            setOpenResendModal(true);
            setLogData(props.data);
          }}
        >
          <ResendIcon stroke="#1f4494" />
        </Button>
      </div>
    );
  };
  const formatDate = (props: any) => {
    return Utility.ConvertToDateTime(props?.data?.createdAt);
  };
  const columnDefs: GridColumnDefs[] = [
    {
      headerName: communicationLogs_LABELS.logId,
      field: "processId",
      cellRenderer: CommunicationLogId,
      align: "center",
    },
    {
      headerName: communicationLogs_LABELS.clinicName,
      field: "clinicName",
      align: "center",
      sortable: true,
    },
    {
      headerName: communicationLogs_LABELS.bpSiteId,
      field: "bpSiteId",
      align: "center",
      sortable: true,
    },
    {
      headerName: communicationLogs_LABELS.finalisedBy,
      field: "finalisedBy",
      align: "center",
      sortable: true,
    },
    {
      headerName: communicationLogs_LABELS.patientName,
      field: "PatientName",
      cellRenderer: PatientName,
      align: "center",
    },
    {
      headerName: communicationLogs_LABELS.status,
      field: "deliveryStatus",
      cellRenderer: DeliveryStatus,
      align: "center",
      sortable: true,
    },
    {
      headerName: communicationLogs_LABELS.initiatedBy,
      field: "initiatedBy",
      align: "center",
      sortable: true,
    },
    {
      headerName: communicationLogs_LABELS.documentsSent,
      field: "documentNames",
      align: "center",
    },
    {
      headerName: communicationLogs_LABELS.reason,
      field: "failedReason",
      align: "center",
    },
    {
      headerName: communicationLogs_LABELS.date,
      field: "createdAt",
      align: "center",
      cellRenderer: formatDate,
      sortable: true,
    },
    {
      headerName: userManagement_LABELS.actions,
      field: "actions",
      cellRenderer: Actions,
      align: "center",
    },
  ];
  const onPageChange = (value: number) => {
    setFilterCriteria({ ...filterCriteria, pageNumber: value });
  };

  const onPageSizeChange = (value: number) => {
    setFilterCriteria({ ...filterCriteria, pageNumber: 1, pageSize: value });
  };

  const searchResults = (value: string) => {
    setSearchString(value);
    setFilterCriteria({
      ...filterCriteria,
      pageNumber: 1,
      searchString: value?.trim().length > 0 ? value.trim() : null,
    });
  };
  const sordOrder = (columnName: string, order: string) => {
    if (order === "asc" || order === "desc") {
      setFilterCriteria({
        ...filterCriteria,
        pageNumber: 1,
        sortByColumnName: columnName,
        sortOrder: order,
      });
      setResetPagination(true);
    } else {
      setFilterCriteria({
        ...filterCriteria,
        pageNumber: 1,
        sortByColumnName: null,
        sortOrder: null,
      });
      setResetPagination(true);
    }
  };
  return (
    <>
      <Modal
        title="Resend"
        headerLogo={<ResendIcon />}
        modalHeaderStyle={{ fontSize: "2rem" }}
        modalWidth="460px"
        isOpen={openResendModal}
        onClose={() => setOpenResendModal(false)}
        closeOnOverLayClick={false}
        headerBg="var(--primary-color)"
        closeIconColor={"var(--white)"}
        children={
          <div className="m-5 d-flex flex-column gap-3 resend-log-details-wrapper no-border">
            <div className="d-flex">
              <div className="log-details-label">Clinic Name: </div>
              <div className="log-details-text">{logData?.clinicName}</div>
            </div>
            <div className="d-flex">
              <div className="log-details-label">BP Site ID: </div>
              <div className="log-details-text">{logData?.bpSiteId}</div>
            </div>
            <div className="d-flex">
              <div className="log-details-label">Patient's Name: </div>
              <div className="log-details-text">{logData?.recipientName}</div>
            </div>
            <div className="d-flex">
              <div className="log-details-label">Documents Sent: </div>
              <div className="log-details-text">{logData?.documentNames}</div>
            </div>
            <div className="d-flex">
              <div className="log-details-label">Last Initiated: </div>
              <div className="log-details-text">
                {Utility.ConvertToDateTime(logData?.createdAt)}
              </div>
            </div>
          </div>
        }
        modalFooter={
          <div className="d-flex justify-content-center py-3">
            <Button
              className="submit-button px-5"
              variant="contained"
              onClick={() => {
                handleSubmit(logData);
                setShowRetryResponse(false);
                getData();
              }}
            >
              Resend
            </Button>
          </div>
        }
      />
      <ConfirmationDialog
        open={showRetryResponse}
        contentBody={
          isRetrySuccess ? (
            <div className="d-flex flex-column justify-content-center  align-items-center gap-4">
              <DoneIcon />
              <div className="confirmation-header">Request Successful</div>
              <p className="pt-4 dialog-body text-align-center">
                The document will be resent to the patient's Correspondence Out
                folder and will be available shortly.
              </p>
            </div>
          ) : (
            <div className="d-flex flex-column justify-content-center  align-items-center gap-4">
              <InfoIcon />
              <div className="confirmation-header">Error</div>
              <p className="pt-4 dialog-body text-align-center">
                We are unable to process your request at this moment, please try
                again later.
              </p>
            </div>
          )
        }
        onOk={() => {
          setShowRetryResponse(false);
          getData();
        }}
        onClose={() => {
          setShowRetryResponse(false);
          getData();
        }}
        okButtonName="Ok"
        okButtonClassName="success-ok"
      />

      <div className="communication-logs-wrapper clinic-grid-wrapper overflow-auto d-flex flex-column">
        <Grid
          columnDefs={columnDefs}
          uniqueIdentifierFieldName="notificationId"
          rowData={rowData}
          serverSidePagination
          resetPagination={resetPagination}
          rowCount={rowcount}
          showPagination
          showFilterIcon
          pageSizeList={[10, 20, 50]}
          pageSize={10}
          showTotalRowCount
          isSearch={searchString?.length > 0}
          filterTemplate={[
            <>
              <MultiSelectDropdown
                placeholder={"Select Clinic Name"}
                canSearch
                searchFilterDropdownPlaceholder={"Clinic"}
                searchFilterDropdownMenuList={clinicsDropDownList}
                displayPropertyName={"clinicName"}
                valuePropertyName={"clinicId"}
                value={selectedClinicsList || [""]}
                width={"235px"}
                onChange={(val: any) => {
                  setSelectedClinicsList(val);
                  setIsApplyFiltersEnabled(true);
                }}
              />
              <MultiSelectDropdown
                placeholder={"Select Status"}
                searchFilterDropdownPlaceholder={"Status"}
                searchFilterDropdownMenuList={[
                  { statusName: "Success", statusId: "1" },
                  { statusName: "Failed", statusId: "2" },
                  { statusName: "In Progress", statusId: "4" },
                ]}
                displayPropertyName={"statusName"}
                valuePropertyName={"statusId"}
                value={statusList}
                width={"200px"}
                canSearch
                onChange={(val: any) => {
                  setStatusList(val);
                  setIsApplyFiltersEnabled(true);
                }}
              />
              <div>
                <DaterangePicker
                  dateRange={dateRange}
                  // allowedDateRange={allowedDateRange}
                  onChange={(val: any) => {
                    if (val !== null) {
                      var minStartDate = dateFns.startOfDay(
                        dateFns.subDays(new Date(), 90)
                      );
                      var maxEndDate = dateFns.endOfDay(new Date());
                      var startDate = new Date(val[0]);
                      var endDate = new Date(val[1]);
                      if (startDate < minStartDate || endDate > maxEndDate) {
                        setError("Select date range within past 90 days");
                        setIsApplyFiltersEnabled(false);
                      } else {
                        setError("");
                        setIsApplyFiltersEnabled(true);
                      }
                    } else {
                      setError("");
                      setIsApplyFiltersEnabled(true);
                    }
                    setDateRange(val);
                  }}
                  setIsApplyFiltersEnabled={setIsApplyFiltersEnabled}
                />
                {error && (
                  <div
                    style={{
                      paddingLeft: "5px",
                    }}
                    className="error-message"
                  >
                    {error}
                  </div>
                )}
              </div>
              <div className="d-flex pt-2 px-2">
                <Button
                  className={"apply"}
                  disabled={!isApplyFiltersEnabled}
                  onClick={() => {
                    const isInProgress = statusList.includes("4");
                    let updatedStatusList = [...statusList];
                    if (isInProgress) {
                      if (!updatedStatusList.includes("3")) {
                        updatedStatusList.push("3");
                      }
                    } else {
                      updatedStatusList = updatedStatusList.filter(
                        (status) => status !== "3"
                      );
                    }
                    setFilterCriteria({
                      ...filterCriteria,
                      pageNumber: 1,
                      filters: [
                        { fieldName: "clinicId", values: selectedClinicsList },
                        {
                          fieldName: "deliveryStatus",
                          values: updatedStatusList,
                        },
                      ],
                      dateRangeCondition: dateRange?.length
                        ? {
                            fromDate: dateRange[0]?.toLocaleDateString("fr-CA"),
                            toDate: dateRange[1]?.toLocaleDateString("fr-CA"),
                          }
                        : null,
                      timezoneOffSet: dateRange?.length
                        ? new Date().getTimezoneOffset()
                        : 0,
                    });
                    setEnableClear(true);
                    setIsApplyFiltersEnabled(false);
                    setResetPagination(true);
                  }}
                >
                  <Apply />
                  <span className="px-2">Apply</span>
                </Button>
              </div>
              <div className="d-flex pt-2 px-2">
                <Button
                  className={"reset"}
                  disabled={!enableClear}
                  onClick={() => {
                    var date = [getPreviousDate(3), new Date()];
                    setSelectedClinicsList([]);
                    setStatusList([]);
                    setDateRange(date);
                    setFilterCriteria({
                      ...filterCriteria,
                      pageNumber: 1,
                      filters: [],
                      dateRangeCondition: {
                        fromDate: date[0].toLocaleDateString("fr-CA"),
                        toDate: date[1].toLocaleDateString("fr-CA"),
                      },
                      timezoneOffSet: 0,
                    });
                    setResetPagination(true);
                    setEnableClear(false);
                    setIsApplyFiltersEnabled(false);
                    setError("");
                  }}
                >
                  <Reset />
                  <span className="px-2">Reset</span>
                </Button>
              </div>
            </>,
          ]}
          canSearch
          resetSuccess={() => {
            setResetPagination(false);
          }}
          setSearchQuery={(values: string) => {
            searchResults(values);
            setResetPagination(true);
          }}
          clearSearch={() => {
            if (
              filterCriteria?.searchString &&
              filterCriteria?.searchString?.length >= 3
            ) {
              searchResults("");
              setResetPagination(true);
            }
          }}
          sortBy={(columnName: string, order: string) => {
            sordOrder(columnName, order);
          }}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
          searchFieldName=""
        />
      </div>
    </>
  );
}

export default BpCommunicationLogsGrid;
